import React from 'react'
import PropTypes from 'prop-types'
import { MatiApiClientProvider } from '@nautilusjs/mati-apis'
import { env, useAuthProvider } from '@maui-mf/root'
import { useUserinfoAppUrls } from '../store/auth/hooks'

export const MATIApiProvider = ({ children }) => {
  const { token } = useAuthProvider()
  const { MA_MSV: msv } = useUserinfoAppUrls()
  const msvHost = msv?.host

  const origin = {
    maApiHost: env.MAAPI_HOST,
    threatProfileNotificationApiHost: env.THREAT_PROFILE_NOTIFICATION_API_HOST,
    threatProfilesApiHost: env.THREAT_PROFILE_API_HOST,
    ...(msvHost && { msvHost }),
  }

  const threatProfilesPathPrefix = env.THREAT_PROFILE_API_PATH_PREFIX
  const threatProfilesNotificationsPathPrefix = env.THREAT_PROFILE_NOTIFICATION_API_PATH_PREFIX

  if (!token) {
    return children
  }

  return (
    <MatiApiClientProvider
      token={token}
      origin={origin}
      threatProfilesPathPrefix={threatProfilesPathPrefix}
      threatProfilesNotificationsPathPrefix={threatProfilesNotificationsPathPrefix}
    >
      {children}
    </MatiApiClientProvider>
  )
}

MATIApiProvider.propTypes = {
  children: PropTypes.node,
}
